module.exports = __webpack_public_path__ + "static/about-us-13-256a6364e3760771b0197c7c2fc43e1e.jpg";